module.exports = __webpack_public_path__ + "img/skull_15_bj.577f8ee1.png";